import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  DraftAppointmentOnFooterFragment,
  GetDraftAppointmentOnFooterDocument,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { useSubscriptions } from '~/hooks/use-subscriptions';

export const useFetchDraftAppointment = (
  draftAppointmentId: string,
): { draftAppointment: DraftAppointmentOnFooterFragment | undefined } => {
  const [event, clear] = useSubscriptions('DraftAppointment', ['updated']);

  const [getDraftAppointment, { data }] = useLazyQuery(GetDraftAppointmentOnFooterDocument, {
    fetchPolicy: 'network-only',
  });

  const draftAppointment = getNode(data, 'DraftAppointment');

  useEffect(() => {
    if (!data || !event) return;
    clear();
  }, [clear, data, event]);

  useEffect(() => {
    getDraftAppointment({ variables: { draftAppointmentId } });
  }, [draftAppointmentId, getDraftAppointment]);

  useEffect(() => {
    if (event?.actionName === 'updated' && event.typeId === draftAppointmentId) {
      getDraftAppointment({ variables: { draftAppointmentId } });
    }
  }, [draftAppointmentId, event?.actionName, event?.typeId, getDraftAppointment]);

  return { draftAppointment };
};
